import { api } from '../../api'

export const deleteBackofficeService = (data: string) => {
  return api.delete(`/api/backoffice/${data}`)
}
